var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.143 9.222c2.047 6.826.46 9.778-6.365 11.826-6.826 2.047-9.778.46-11.826-6.365-2.047-6.826-.46-9.778 6.365-11.826 6.826-2.047 9.778-.46 11.826 6.365zm-3.445 4.429a1.03 1.03 0 0 0 .651-1.302 1.03 1.03 0 0 0-1.301-.65l-1.286.428-.857-2.556 1.285-.428a1.03 1.03 0 0 0 .651-1.302 1.03 1.03 0 0 0-1.301-.65l-1.286.428-.444-1.333a1.03 1.03 0 0 0-1.302-.651 1.03 1.03 0 0 0-.65 1.302l.444 1.333-2.651.889-.445-1.334a1.03 1.03 0 0 0-1.301-.65 1.03 1.03 0 0 0-.651 1.301l.444 1.334-1.285.428a1.03 1.03 0 0 0-.651 1.302c.143.412.54.682.952.698a.886.886 0 0 0 .35-.048l1.285-.428.857 2.555-1.285.429a1.03 1.03 0 0 0-.651 1.302c.143.412.54.682.952.698a.886.886 0 0 0 .35-.048l1.285-.428.445 1.333c.142.413.54.683.952.699a.886.886 0 0 0 .35-.048 1.03 1.03 0 0 0 .65-1.302l-.444-1.333 2.65-.889.445 1.333c.143.413.54.683.952.699a.886.886 0 0 0 .35-.048 1.03 1.03 0 0 0 .65-1.301l-.444-1.334 1.285-.428zm-7.404-2.52l2.65-.886.856 2.558-2.649.888-.857-2.56z",
    id: "slack-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#slack-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.48da6c670b7a3a647c509932cfdef27c.svg";
export { ForwardRef as ReactComponent };